'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-color-stripe',
    cnNoPadding = "".concat(CLASSNAME, "--no-padding"),
    cnPaddingBottom = "".concat(CLASSNAME, "--padding-bottom"),
    cnNegativeMarginTop = "".concat(CLASSNAME, "--negative-margin-top");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function ColorStripe(_ref) {
  var _classNames;

  var children = _ref.children,
      negativeMarginTop = _ref.negativeMarginTop,
      noPadding = _ref.noPadding,
      paddingBottom = _ref.paddingBottom,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, "".concat(CLASSNAME, "--").concat(style), style), _rollupPluginBabelHelpers.defineProperty(_classNames, cnNoPadding, noPadding), _rollupPluginBabelHelpers.defineProperty(_classNames, cnPaddingBottom, paddingBottom), _rollupPluginBabelHelpers.defineProperty(_classNames, cnNegativeMarginTop, negativeMarginTop), _classNames))
  }, children);
}
ColorStripe.propTypes = {
  /** Child nodes or simple string */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /** Negative margin top => pull content out */
  negativeMarginTop: PropTypes.bool,

  /** Remove padding */
  noPadding: PropTypes.bool,

  /** Ensure margin bottom */
  paddingBottom: PropTypes.bool,

  /** Which style */
  style: PropTypes.oneOf(['light', 'dark'])
};

module.exports = ColorStripe;
